import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { ClientBookingPeriodsResponseData } from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const CLIENT_BOOKING_PERIODS_QUERY_KEY = 'client_booking_periods';

export const useClientBookingPeriodsQuery = (
  url: string,
  date: string | null,
) =>
  useQuery({
    queryKey: [CLIENT_BOOKING_PERIODS_QUERY_KEY, url, date],
    queryFn: () =>
      HttpClient.request<ClientBookingPeriodsResponseData>({
        method: 'GET',
        url,
        params: { date },
        headers: {
          Accept: 'application/json',
        },
      }),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: !!date,
  });
